import * as RadixTooltip from '@radix-ui/react-tooltip';
import { ComponentProps, forwardRef } from 'react';

import { popover } from '@/styles/popover';

import styles from './styles.module.css';

function Provider({
  children,
  delayDuration = 250,
  disableHoverableContent,
  skipDelayDuration,
}: ComponentProps<typeof RadixTooltip.Provider>) {
  return (
    <RadixTooltip.Provider
      delayDuration={delayDuration}
      disableHoverableContent={disableHoverableContent}
      skipDelayDuration={skipDelayDuration}
    >
      {children}
    </RadixTooltip.Provider>
  );
}

const Root = RadixTooltip.Root;
const Portal = RadixTooltip.Portal;
const Trigger = RadixTooltip.Trigger;

const Content = forwardRef<HTMLDivElement, ComponentProps<typeof RadixTooltip.Content>>(
  function Content({ children, className, ...rest }, forwardedRef) {
    return (
      <RadixTooltip.Content
        ref={forwardedRef}
        className={popover().content({
          class: [
            'bg-special-background-tooltip',
            'text-token-gray-1600',
            'shadow-25',
            styles.animateContent,
            className,
          ],
        })}
        sideOffset={12}
        {...rest}
      >
        {children}
      </RadixTooltip.Content>
    );
  },
);

export const Tooltip = { Provider, Root, Portal, Trigger, Content };
